import { ReactNode } from "react";
import PublicPageLayout from "./PublicPageLayout";
import DisciplineNavigation from "../DisciplineNavigation";

export default function PublicDisciplineLayout({ title, intro, children }: { title: string; intro?: string; children: ReactNode }) {
  return <PublicPageLayout title={title} eyebrow="La pesca sportiva" intro={intro} navigation={<DisciplineNavigation />}>
    {children}
  </PublicPageLayout>;
}
